import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.flat-map.js";
import { defineComponent as _defineComponent } from 'vue';
import VabProgress from 'nprogress';
import { useSettingsStore } from '@/store/modules/settings';
import { useTabsStore } from '@/store/modules/tabs';
import { handleActivePath } from '@/utils/routes';
import { keepAliveMaxNum } from '@/config';

import { useRoute } from 'vue-router';
import { inject, ref, watchEffect, nextTick } from 'vue';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const route = useRoute();
    const $sub = inject('$sub');
    const $unsub = inject('$unsub');
    const settingsStore = useSettingsStore();
    const {
      theme
    } = storeToRefs(settingsStore);
    const tabsStore = useTabsStore();
    const {
      getVisitedRoutes: visitedRoutes
    } = storeToRefs(tabsStore);
    const componentRef = ref();
    const routerKey = ref();
    const keepAliveNameList = ref();
    const updateKeepAliveNameList = (refreshRouteName = null) => {
      keepAliveNameList.value = visitedRoutes.value.filter(item => !item.meta.noKeepAlive && item.name !== refreshRouteName).flatMap(item => item.name);
    };
    // 更新KeepAlive缓存页面
    watchEffect(() => {
      routerKey.value = handleActivePath(route, true);
      updateKeepAliveNameList();
    });
    // 获取源码地址
    $sub('get-code', () => {
      window.open(`https://github.com/zxwk2024/admin-plus/blob/main/${componentRef.value.$options.__source}`);
    });
    $sub('reload-router-view', (refreshRouteName = route.name) => {
      if (theme.value.showProgressBar) VabProgress.start();
      const cacheActivePath = routerKey.value;
      routerKey.value = null;
      updateKeepAliveNameList(refreshRouteName);
      nextTick(() => {
        routerKey.value = cacheActivePath;
        updateKeepAliveNameList();
      });
      setTimeout(() => {
        if (theme.value.showProgressBar) VabProgress.done();
      }, 200);
    });
    // onUnmounted(() => {
    //     $unsub('get-code')
    //     $unsub('reload-router-view')
    // })
    const __returned__ = {
      route,
      $sub,
      $unsub,
      settingsStore,
      theme,
      tabsStore,
      visitedRoutes,
      componentRef,
      routerKey,
      keepAliveNameList,
      updateKeepAliveNameList,
      get keepAliveMaxNum() {
        return keepAliveMaxNum;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});